"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var material_1 = require("@mui/material");
var SelectedVacancy_1 = __importDefault(require("./SelectedVacancy"));
var VacancySkeleton_1 = __importDefault(require("./VacancySkeleton"));
var Vacancy_1 = __importDefault(require("../models/Vacancy"));
var CompanyCard_1 = __importDefault(require("./CompanyCard"));
var ApplyWithRFCard_1 = __importDefault(require("./ApplyWithRFCard"));
var ApplyDialog_1 = __importDefault(require("./components/ApplyDialog"));
var VacancyContainer = function () {
    var _a = (0, react_router_dom_1.useParams)(), vacancyParam = _a.vacancyId, slug = _a.slug;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var vacancyId = (0, react_1.useMemo)(function () {
        if (!vacancyParam) {
            return undefined;
        }
        return Number(vacancyParam);
    }, [vacancyParam]);
    var _b = (0, react_query_1.useQuery)(['vacancy', vacancyId], function () {
        return axios_1.default.get("/data/vacancies/".concat(vacancyId)).then(function (result) { return result.data; });
    }), isLoading = _b.isLoading, vacancy = _b.data;
    (0, react_1.useEffect)(function () {
        if (!slug && (vacancy === null || vacancy === void 0 ? void 0 : vacancy.slug)) {
            navigate(vacancy.slug);
        }
    }, [navigate, slug, vacancyId, vacancy === null || vacancy === void 0 ? void 0 : vacancy.slug]);
    (0, react_1.useEffect)(function () {
        if (vacancyId) {
            Vacancy_1.default.registerVisit(vacancyId);
        }
    }, [vacancyId]);
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(VacancySkeleton_1.default, {});
    }
    if (!vacancy) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ spacing: 8 }, { children: [(0, jsx_runtime_1.jsx)(ApplyDialog_1.default, { vacancy: vacancy }), (0, jsx_runtime_1.jsx)(SelectedVacancy_1.default, { vacancy: vacancy }, vacancy.id), (0, jsx_runtime_1.jsx)(ApplyWithRFCard_1.default, {}), (0, jsx_runtime_1.jsx)(CompanyCard_1.default, { vacancy: vacancy })] })));
};
exports.default = VacancyContainer;
